// PRIVATE DATA!
// DO NOT IMPORT THIS DIRECTLY IN YOUR PROJECT!
// IT CAN BE CHANGED AT ANY TIME
export default /[\s(]Windows\s(NT|Mobile)\s([\d.]+)[;)]/;
